import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface User {
  id: string
  email: string
  name: string
  role: string
  status: 'pending' | 'approved' | 'rejected'
  createdAt: string
}

interface UserState {
  users: User[]
  loading: boolean
  error: string | null
  totalUsers: number
  currentPage: number
  pageSize: number
}

const initialState: UserState = {
  users: [],
  loading: false,
  error: null,
  totalUsers: 0,
  currentPage: 1,
  pageSize: 10
}

const userSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setUsers: (state, action: PayloadAction<User[]>) => {
      state.users = action.payload
    },
    addUser: (state, action: PayloadAction<User>) => {
      state.users.push(action.payload)
    },
    updateUser: (state, action: PayloadAction<User>) => {
      const index = state.users.findIndex(user => user.id === action.payload.id)
      if (index !== -1) {
        state.users[index] = action.payload
      }
    },
    removeUser: (state, action: PayloadAction<string>) => {
      state.users = state.users.filter(user => user.id !== action.payload)
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload
      state.loading = false
    },
    clearError: (state) => {
      state.error = null
    },
    setTotalUsers: (state, action: PayloadAction<number>) => {
      state.totalUsers = action.payload
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    }
  }
})

export const {
  setUsers,
  addUser,
  updateUser,
  removeUser,
  setLoading,
  setError,
  clearError,
  setTotalUsers,
  setCurrentPage
} = userSlice.actions

export default userSlice.reducer
